import React from 'react';

import { TOWNSQUARE_APP_SWITCHER_START_SLOTS } from '@townsquare/nav-platform-integration/app-switcher-slot';
import type {
	TownsquareAppHomeSlot,
	TownsquareTopNavStartSlots,
} from '@townsquare/nav-platform-integration/global-root';

import { useProductHomeDetails } from '../navigation/use-product-home-details';

const HomeAppHomeSlot: TownsquareAppHomeSlot = ({ AppHomeComponent, context }) => {
	const { Icon, name, href, label, onClick } = useProductHomeDetails();

	return (
		<AppHomeComponent
			appName={name}
			icon={Icon}
			href={href}
			label={label}
			onClick={onClick}
			queryRef={context.queryRef}
		/>
	);
};

export const HOME_TOP_NAV_START_SLOTS: Required<TownsquareTopNavStartSlots> = {
	...TOWNSQUARE_APP_SWITCHER_START_SLOTS,
	AppHomeSlot: HomeAppHomeSlot,
};
